import React from "react";
import { ORIENTATION, StatefulCalendar } from "baseui/datepicker";
import { MULTI_CITY_TRIP, ONE_WAY_TRIP, ROUND_TRIP } from "constants/common";
import { addDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

export default function FlightDatePicker({
  handleDateChange,
  tripType,
  minDate,
  startDate,
  endDate,
}) {
  // console.log("startDate", startDate);
  // console.log("startDate endDate", startDate, endDate);
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(null);
  // const onChange = (dates) => {
  //   const [start, end] = dates;
  //   setStartDate(start);
  //   setEndDate(end);
  // };
  if (minDate) {
  }
  return (
    <div>
      {(tripType === ONE_WAY_TRIP || tripType === MULTI_CITY_TRIP) && (
        <StatefulCalendar
          onChange={({ date }) => handleDateChange(date)}
          orientation={ORIENTATION.horizontal}
          monthsShown={2}
          className="flights-calendar"
          range={false}
          minDate={minDate ? new Date(minDate) : new Date()}
          value={startDate}
          // overrides={{
          //   MonthContainer: {
          //     style: ({ $theme }) => ({
          //       outline: `${$theme.colors.warning200} solid`,
          //       backgroundColor: $theme.colors.warning200,
          //       width: "100px",
          //     }),
          //   },
          // }}
        />
      )}
      {tripType === ROUND_TRIP && (
        <StatefulCalendar
          onChange={({ date }) => handleDateChange(date)}
          orientation={ORIENTATION.horizontal}
          monthsShown={2}
          className="flights-calendar"
          range={true}
          initialState={{ value: [startDate, endDate] }}
          value={[new Date(), addDays(new Date(), 10)]}
          density={1}
          minDate={minDate ? new Date(minDate) : new Date()}
          // overrides={{
          //   Popover: {
          //     style: ({ $theme }) => ({
          //       // outline: `${$theme.colors.warning200} solid`,
          //       // backgroundColor: $theme.colors.warning200,
          //       // fontSize:"10px"
          //       height:"200px"
          //     })
          //   },

          //   Day: {
          //     style: ({ $theme, $selected, $isHovered, $isHighlighted }) => ({
          //       color: $selected || $isHovered
          //         ? $theme.colors.white
          //         : $theme.colors.calendarForeground,
          //       // fontSize: "12px",
          //       ":after": {
          //         backgroundColor: $selected
          //           ? $isHovered || $isHighlighted
          //             ? $theme.colors.positive500
          //             : $theme.colors.positive
          //           : $isHovered || $isHighlighted
          //           ? 'white'
          //           : "transparent",
          //       },
          //     }),
          //   },
          // }}
        // <DatePicker
        //   selected={startDate}
        //   onChange={onChange}
        //   startDate={startDate}
        //   endDate={endDate}
        //   monthsShown={2}
        //   inline
        //   selectsRange
        // />
        // overrides={{
        //   Popover: {
        //     Body: {
        //       overrides: {
        //         style: ({
        //           $theme,
        //           $selected,
        //           $isHovered,
        //           $isHighlighted,
        //         }) => ({
        //           width: "300px",
        //         }),
        //         // pass "nested" overrides to the inner "Boo" component
        //       },
        //     },
        //   },
        // }}
        />
      )}
    </div>
  );
}
